import { render } from "./wcPromotion.vue?vue&type=template&id=730386ed&scoped=true"
import script from "./wcPromotion.vue?vue&type=script&lang=js"
export * from "./wcPromotion.vue?vue&type=script&lang=js"

import "./wcPromotion.vue?vue&type=style&index=0&id=730386ed&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730386ed"]])

export default __exports__